  import React, { useState, useEffect } from "react";
  import { useNavigate } from "react-router-dom";
  import { useAuth } from "../../context/AuthContext";
  import { useCart } from "../../context/CartContext";
  import { getCategories } from "../../services/api";
  import { GiBigDiamondRing } from "react-icons/gi";

  const Navbar = () => {
    const navigate = useNavigate();
    const { isAuthenticated, user, logout, openLoginModal } = useAuth();
    const { getCartCount, wishlistItems } = useCart();

    const [searchQuery, setSearchQuery] = useState("");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [profileOpen, setProfileOpen] = useState(false);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
      const fetchCategories = async () => {
        try {
          const response = await getCategories();
          setCategories(response.data);
        } catch (err) {
          console.log("Error fetching categories:", err);
        }
      };
      fetchCategories();
    }, []);

    const handleSearch = (e) => {
      if (e.key === "Enter" && searchQuery.trim()) {
        navigate(`/filter?search=${encodeURIComponent(searchQuery.trim())}`);
        setSearchQuery("");
      }
    };

    const handleLogout = () => {
      logout();
      setProfileOpen(false);
      navigate("/");
    };

    return (
      <>
        <nav className="navbar">
          <div className="nav-left">
            <div className="menu-btn" onClick={() => setDrawerOpen(true)}>☰</div>
            <div className="logo" onClick={() => navigate("/")}>
              <div className="mlogo">
                RoopShingar
                <GiBigDiamondRing className="logo-icon"/>
              </div>
            </div>
          </div>

          <div className="nav-center">
            <input
              type="text"
              placeholder="Search jewellery here..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={handleSearch}
            />
          </div>

          <div className="nav-right">
            <div onClick={() => navigate("/wishlist")} className="icon">
              ❤️
              {wishlistItems.length > 0 && (
                <span className="badge">{wishlistItems.length}</span>
              )}
            </div>

            <div onClick={() => navigate("/cart")} className="icon">
              🛒
              {getCartCount() > 0 && (
                <span className="badge">{getCartCount()}</span>
              )}
            </div>

            {isAuthenticated ? (
              <div className="profile">
                <span className="user-name" onClick={() => setProfileOpen(!profileOpen)}>
                  {user?.name}
                </span>

                {profileOpen && (
                  <div className="profile-menu">
                    <div onClick={() => { navigate("/profile"); setProfileOpen(false); }}>My Profile</div>
                    <div onClick={() => { navigate("/orders"); setProfileOpen(false); }}>My Orders</div>
                    <div onClick={() => { navigate("/wishlist"); setProfileOpen(false); }}>Wishlist</div>
                    <hr />
                    <div onClick={handleLogout} className="logout-item">Logout</div>
                  </div>
                )}
              </div>
            ) : (
              <button onClick={openLoginModal} className="login-btn">
                Login
              </button>
            )}
          </div>
        </nav>

        {/* Drawer Menu */}
        {drawerOpen && (
          <div className="drawer-overlay" onClick={() => setDrawerOpen(false)}>
            <div className="drawer" onClick={(e) => e.stopPropagation()}>
              <div className="drawer-header">
                <h3 className="drawer-title">Menu</h3>
                <span className="close-btn" onClick={() => setDrawerOpen(false)}>✖</span>
              </div>

              <div className="drawer-content">
                <div className="drawer-item" onClick={() => { navigate("/"); setDrawerOpen(false); }}>Home</div>
                <div className="drawer-item" onClick={() => { navigate("/filter/All"); setDrawerOpen(false); }}>Shop All</div>
                <div className="drawer-item" onClick={() => { navigate("/about"); setDrawerOpen(false); }}>About</div>
                <div className="drawer-item" onClick={() => { navigate("/Offers"); setDrawerOpen(false); }}>Offers</div>
                <div className="drawer-item" onClick={() => { navigate("/policy"); setDrawerOpen(false); }}>policy</div>



                <hr className="drawer-hr" />
                <p className="drawer-label">Categories</p>
                
                {categories.map((cat) => (
                  <div
                    key={cat._id}
                    className="drawer-item"
                    onClick={() => {
                      navigate(`/filter/${cat._id}`);
                      setDrawerOpen(false);
                    }}
                  >
                    {cat.CategoryName}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        
      </>
    );
  };

  export default Navbar;